import { CLEAR, PAUSED, PLAY, REPEAT_ALL, REPEAT_OFF, REPEAT_ONE, RESUMED, SET_MEDIA, SET_PLAY_QUEUE_CONTROL, SHUFFLE_OFF, SHUFFLE_ON, STARTED, THUMBS_DOWN, THUMBS_UP, UNDO_THUMBS_DOWN, UNDO_THUMBS_UP, } from '../actions/Playback';
const initialState = {};
function updateState(state, props) {
    const newPropsValue = props.reduce((newProps, prop) => {
        if (!state[prop.name]) {
            return newProps;
        }
        else {
            return Object.assign(Object.assign({}, newProps), { [prop.name]: Object.assign(Object.assign({}, state[prop.name]), { state: prop.value }) });
        }
    }, {});
    return Object.assign(Object.assign({}, state), newPropsValue);
}
const reducer = {
    [CLEAR]: () => initialState,
    [SET_MEDIA]: (state, action) => {
        if (action.payload.states) {
            return Object.assign(Object.assign({}, state), action.payload.states);
        }
        else {
            return state;
        }
    },
    [RESUMED]: (state, action) => {
        return updateState(state, [{ name: 'play', value: 'PLAYING' }]);
    },
    [PLAY]: (state, action) => {
        return updateState(state, [{ name: 'play', value: 'PLAYING' }]);
    },
    [STARTED]: (state, action) => {
        return updateState(state, [{ name: 'play', value: 'PLAYING' }]);
    },
    [PAUSED]: (state, action) => {
        return updateState(state, [{ name: 'play', value: 'PAUSED' }]);
    },
    [SHUFFLE_ON]: (state, action) => {
        return updateState(state, [{ name: 'shuffle', value: 'ON' }]);
    },
    [SHUFFLE_OFF]: (state, action) => {
        return updateState(state, [{ name: 'shuffle', value: 'OFF' }]);
    },
    [REPEAT_OFF]: (state, action) => {
        return updateState(state, [{ name: 'repeat', value: 'OFF' }]);
    },
    [REPEAT_ALL]: (state, action) => {
        return updateState(state, [{ name: 'repeat', value: 'ALL' }]);
    },
    [REPEAT_ONE]: (state, action) => {
        return updateState(state, [{ name: 'repeat', value: 'ONE' }]);
    },
    [THUMBS_UP]: (state, action) => {
        return updateState(state, [
            { name: 'thumbsUp', value: 'ON' },
            { name: 'thumbsDown', value: 'OFF' },
        ]);
    },
    [UNDO_THUMBS_UP]: (state, action) => {
        return updateState(state, [{ name: 'thumbsUp', value: 'OFF' }]);
    },
    [THUMBS_DOWN]: (state, action) => {
        return updateState(state, [
            { name: 'thumbsUp', value: 'OFF' },
            { name: 'thumbsDown', value: 'ON' },
        ]);
    },
    [UNDO_THUMBS_DOWN]: (state, action) => {
        return updateState(state, [{ name: 'thumbsDown', value: 'OFF' }]);
    },
    [SET_PLAY_QUEUE_CONTROL]: (state, action) => {
        return Object.assign(Object.assign({}, state), { visualPlayQueue: action.payload.visualPlayQueue });
    },
};
export function PlaybackStatesReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
